export const productTypeSelect = {
	label: "Tipo do produto",
	placeholder: "Selecione o tipo",
	loading: "Carregando...",
};
